
<div class="container {{ OBJ_LNG_NAME }} delete">
  <h1 mat-dialog-title>
    {{ 'allgemein.löschen' | translate:locale.language:{ typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}
    <button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
    <mat-progress-bar *ngIf="dataService.isRequestRunning" color="primary" mode="indeterminate"></mat-progress-bar>
  </h1>
  <mat-dialog-content>
    <p class="errors" *ngIf="dataService.fehler" [innerHTML]="dataService.fehler.messagehtml"></p>
  	<div *ngIf="!dataService.fehler">
		<p *ngIf="UEBERSETZUNG_FELDNAME != null">{{ 'allgemein.löschenfrage' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME+'.artikel.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.typ' | translate:locale.language, name: aktuell[UEBERSETZUNG_FELDNAME] } }}</p>
		<p *ngIf="UEBERSETZUNG_FELDNAME == null">>{{ 'allgemein.löschenfrage' | translate:locale.language:{ bestimmt: OBJ_LNG_NAME+'.artikel.bestimmt' | translate:locale.language, typ: OBJ_LNG_NAME+'.typ' | translate:locale.language } }}</p>
 	</div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button *ngIf="!dataService.fehler" mat-raised-button type="button" (click)="close()" [disabled]="dataService.isRequestRunning">{{ 'allgemein.nein' | translate:locale.language }}</button>
    <button *ngIf="dataService.fehler" mat-raised-button type="button" (click)="close()" color="primary" [disabled]="dataService.isRequestRunning">{{ 'allgemein.close' | translate:locale.language }}</button>
    <button *ngIf="!dataService.fehler" mat-raised-button type="button" (click)="loeschen()" color="primary" [disabled]="dataService.isRequestRunning">
      <mat-spinner *ngIf="dataService.isRequestRunning" [diameter]="30"></mat-spinner>
      {{ (dataService.isRequestRunning ? 'allgemein.daten.verarbeiten' : 'allgemein.ja' ) | translate:locale.language }}
    </button>
  </mat-dialog-actions>
</div>
